import React, {useState} from 'react';
import badges from 'src/assets/badges.svg'
import tags from 'src/assets/tags.svg'
import papers from 'src/assets/papers.svg'
import selectDot from 'src/assets/selectDot.svg'
import unselectDot from 'src/assets/unselectDot.svg'
import leftArrow from 'src/assets/carouselLeftArrow.svg'
import rightArrow from 'src/assets/carouselRightArrow.svg'
import ActionButton from "../components/ActionButton";
import {useShowFTEMutation} from "../app/appApiQueries";
import Spinner from "../components/Spinner";

const Onboarding: React.FC = () => {
    const images = [papers, badges, tags];
    const headers = ['Create a session to start assigning badges', 'Keep track of score', 'Organize multiple sessions of participants with tags']
    const contents = ['Playing trivia? Tracking attendance? Encouraging participation? Badges can help record all types of participant engagement.', 'Head to the "Leaderboard" to see how participants engaged in each session. You can also export results here.', 'You can organize badges by assigning tags to keep sessions categorized.']
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [updateShowFTE, {isLoading}] =
        useShowFTEMutation()

    const goToPreviousImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const goToNextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };
    const openHome = () => {
        updateShowFTE(false)
    }

    return (<div className="flex flex-col min-h-screen justify-center">
            <div className="flex justify-center items-center flex-col" >
            <div className="flex flex-row items-center h-full px-4 justify-between w-full">

                <div className="slider-arrow left w-16" onClick={goToPreviousImage}>
                    {currentImageIndex !== 0 && (
                        <>
                            <img className="max-w-none h-min"
                                 src={leftArrow} alt="Left Arrow"/>
                        </>
                    )}
                </div>

                <div className="w-full h-96">
                    <div className="image-container flex justify-center">
                        <img className="object-contain"
                            src={images[currentImageIndex]}
                            alt=""
                        />
                    </div>
                    <div className="text-center justify-center flex flex-wrap">
                        <h5 className="mt-6 text-lg font-bold">{headers[currentImageIndex]}</h5>
                    </div>
                    <div className="text-container text-center justify-center flex flex-wrap">
                        <p className="mt-3">{contents[currentImageIndex]}</p>
                    </div>
                    {currentImageIndex === 2 && (
                        <>
                            <div className="mt-6 flex justify-center">
                                <ActionButton
                                    type="primary"
                                    padding="lg"
                                    ariaLabel="Get started"
                                    onClick={openHome}
                                >
                                    {isLoading ? <Spinner className="h-8 stroke-white"/> : 'Get started'}
                                </ActionButton>
                            </div>
                        </>
                    )}
                </div>
                <div className="slider-arrow right w-16" onClick={goToNextImage}>
                    {currentImageIndex !== 2 && (
                        <>
                            <img className="max-w-none h-min"
                                 src={rightArrow} alt="Right Arrow"/>
                        </>
                    )}
                </div>
            </div>

            <div className="flex justify-center w-full py-2 gap-2 mt-28">
                <div className="center" onClick={() => setCurrentImageIndex(0)}>
                    <img className="max-w-none h-min"
                         src={currentImageIndex === 0 ? selectDot : unselectDot} alt="Right Arrow"/> {/* You can use an image or custom arrow here */}
                </div>
                <div className="center" onClick={() => setCurrentImageIndex(1)}>
                    <img className="max-w-none h-min"
                         src={currentImageIndex === 1 ? selectDot : unselectDot} alt="Right Arrow"/> {/* You can use an image or custom arrow here */}
                </div>
                <div className="center" onClick={() => setCurrentImageIndex(2)}>
                    <img className="max-w-none h-min"
                         src={currentImageIndex === 2 ? selectDot : unselectDot} alt="Right Arrow"/> {/* You can use an image or custom arrow here */}
                </div>
            </div>
            </div>
        </div>
    );
};

export default Onboarding;
